import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {
  constructor() {}

  static get(key: string) {
    try {
      const item = sessionStorage.getItem(key);

      return item ? JSON.parse(item) : null;
    } catch (error) {
      return null;
    }
  }

  static set(key: string, item: any) {
    sessionStorage.setItem(key, JSON.stringify(item));
  }

  static remove(key: string) {
    sessionStorage.removeItem(key);
  }

  static clear() {
    sessionStorage.clear();
  }

  clearSessionStorage(
    storageKeysArray: string[],
    existingKeysSet: Set<string>,
    keysToRemoveNumber: number
  ) {
    for (let i = 0; i <= keysToRemoveNumber; i++) {
      const oldestKey = storageKeysArray.shift();

      if (oldestKey && existingKeysSet.size > 1) {
        sessionStorage.removeItem(oldestKey);
        existingKeysSet.delete(oldestKey);
      }
    }
  }

  getParsedData(): {[key: string]: any} {
    const parsedStorage: {[key: string]: any} = {};

    for (let i = 0; i < sessionStorage.length; i++) {
      const key = sessionStorage.key(i);

      if (key) {
        try {
          const item = sessionStorage.getItem(key);

          if (item) {
            parsedStorage[key] = JSON.parse(item);
          }
        } catch (error) {
          continue;
        }
      }
    }

    return parsedStorage;
  }
}
